import script from "./services.vue?vue&type=script&setup=true&lang=ts"
export * from "./services.vue?vue&type=script&setup=true&lang=ts"

import "./services.vue?vue&type=style&index=0&id=5caf60a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5caf60a8"]])

export default __exports__